var React = require('react');

function DownloadArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.0002 3C11.6741 3 10.4023 3.52678 9.46462 4.46447C8.52694 5.40215 8.00015 6.67392 8.00015 8V17.5858L3.70726 13.2929L3.00015 12.5858L1.58594 14L2.29304 14.7071L8.29304 20.7071C8.68357 21.0976 9.31673 21.0976 9.70726 20.7071L15.7073 14.7071L16.4144 14L15.0002 12.5858L14.293 13.2929L10.0002 17.5858V8C10.0002 7.20435 10.3162 6.44129 10.8788 5.87868C11.4414 5.31607 12.2045 5 13.0002 5H20.0002H21.0002V3H20.0002H13.0002Z","fill":"#303030"}));
}

DownloadArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DownloadArrow;

DownloadArrow.default = DownloadArrow;
